import { ElementRef, Injectable } from '@angular/core';
import CameraControls from 'camera-controls';
import { BehaviorSubject, Subject } from 'rxjs';
import { HostDimensions } from 'src/app/core/interfaces/host-dimensions';
import { GlobalBuilder } from 'src/app/core/models/3D/object-builders/global-builder.model';
import { CameraInstructions } from 'src/app/core/models/3D/utils/camera-instructions';
import { OrthographicCamera, PerspectiveCamera, Renderer, Scene } from 'three';
import { CameraTypes } from '../camera/camera-types';

@Injectable({
  providedIn: 'root',
})
export class StatesService {
  public renderer = new BehaviorSubject<Renderer>(null);
  public camera = new BehaviorSubject<PerspectiveCamera | OrthographicCamera>(null);
  public controls = new BehaviorSubject<CameraControls>(null);
  public scene = new BehaviorSubject<Scene>(null);
  public depth = new BehaviorSubject<number>(null);
  public worldSize = new BehaviorSubject<number>(GlobalBuilder.MIN_WORLD_SIZE);
  public host = new BehaviorSubject<HostDimensions>(null);
  public elementRef = new BehaviorSubject<ElementRef>(null);
  public cameraType = new BehaviorSubject<CameraTypes>(CameraTypes.PERSPECTIVE);
  public focus = new BehaviorSubject<CameraInstructions>(null);
  public dispose = new Subject<void>();
}
